import { css } from 'linaria';
import { Variables } from '../index';

export const globalsDateStyles = css`
    :global() {
        /* DayPicker styles */

        .DayPicker {
            display: inline-block;
            font-size: 1rem;
        }

        .DayPicker-wrapper {
            position: relative;

            flex-direction: row;
            padding-bottom: 1em;

            -webkit-user-select: none;

            -moz-user-select: none;

            -ms-user-select: none;

            user-select: none;
        }

        .DayPicker-Months {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }

        .DayPicker-Month {
            display: table;
            margin: 0 1em;
            margin-top: 1em;
            border-spacing: 0;
            border-collapse: collapse;

            -webkit-user-select: none;

            -moz-user-select: none;

            -ms-user-select: none;

            user-select: none;
        }

        .DayPicker-NavBar {
        }

        .DayPicker-NavButton {
            position: absolute;
            top: 1em;
            right: 1.5em;
            left: auto;

            display: inline-block;
            margin-top: 2px;
            width: 1.25em;
            height: 1.25em;
            background-position: center;
            background-size: 50%;
            background-repeat: no-repeat;
            color: #8b9898;
            cursor: pointer;
        }

        .DayPicker-NavButton:hover {
            opacity: 0.8;
        }

        .DayPicker-NavButton--prev {
            margin-right: 48px;
            background-size: 100%;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEVSURBVHgBtZUxDsIwDEUNLB0zslFOAGyMsLFyArgB4gRwA7gJMxNlYwNOQI6QsRt8q0ZUKAGXlC9ZrtvkyUpst0U/yBgzT5Kkl+f5leoQgAvYXazvW9OgChLIWULrnOv61jVJD0zhdk8gbBxaq8pUgAcYe8dAZHkJrddmuhMga/kJqBKy3JQuZk2xAmRVAm4pVm+lc6iytxEApnA3CS1sgHN0pFToogxFyAuV211KmNKrPlVqhT6gr0/obz6eEYPxbPBuTzFQAWeAcStyew7xzO+OFANlAZTBTWBt2Aix/Tad/tKm6iklYJ5QXBmWioFifZWmnlLYbOGmEqZUZO4tPTVUwBkVpXaHdai4wHrEvxPYLPT9Afb7XgRt2VNoAAAAAElFTkSuQmCC');
        }

        .DayPicker-NavButton--next {
            background-size: 100%;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEOSURBVHgBrZWhEsIwDIYzMJOV4DaHZA45HJK9ATwBjwA8yTRqWBRIHEjkHqG4OfhzF+52u3VklP8u16ztvmZJrhuSQ8aYTRiG46qqHvQPAZjCXmJL6qmBY/4OK8XPAZ5SDwWuBYAiDDd25YC5tbYkhVyRkgAyeYxgBQ4ypNCwaxFFKlGsJ9wFbASbYO5APlABXwHmNKUMhW8wd/KCCvgCWAyXCzbj6Pkw1/6AlJJ8ngXMypD3oxdUwJGAebSwGGDb3DcgP7V2gxpa+/xIptauvu0TaV4D7l35VAtBbmt3wY581QAWmneCL0C+oT6gEpa0VVsN9blQgg5gvR8TLZDlqr4hRev0FqJd8R+AftAbVShjjFEzFFIAAAAASUVORK5CYII=');
        }

        .DayPicker-NavButton--prev,
        .DayPicker-NavButton--next {
            &:hover,
            &:focus-visible {
                background-color: rgba(16, 16, 16, 0.08);
                opacity: 1;
            }
            &:active {
                background-color: rgba(16, 16, 16, 0.12);
            }
        }

        .DayPicker-NavButton--interactionDisabled {
            display: none;
        }

        .DayPicker-Caption {
            display: table-caption;
            margin-bottom: 0.5em;
            padding: 0 0.5em;
            text-align: left;
        }

        .DayPicker-Caption > div {
            font-weight: 500;
            font-size: 1.15em;
        }

        .DayPicker-Weekdays {
            display: table-header-group;
            margin-top: 1em;
        }

        .DayPicker-WeekdaysRow {
            display: table-row;
        }

        .DayPicker-Weekday {
            display: table-cell;
            padding: 0.5em;
            color: #8b9898;
            text-align: center;
            font-size: 0.875em;
        }

        .DayPicker-Weekday abbr[title] {
            border-bottom: none;
            text-decoration: none;
        }

        .DayPicker-Body {
            display: table-row-group;
        }

        .DayPicker-Week {
            display: table-row;
        }

        .DayPicker-Day {
            display: table-cell;
            padding: 0.5em;
            border-radius: 50%;
            vertical-align: middle;
            text-align: center;
            cursor: pointer;
        }

        .DayPicker-WeekNumber {
            display: table-cell;
            padding: 0.5em;
            min-width: 1em;
            border-right: 1px solid #eaecec;
            color: #8b9898;
            vertical-align: middle;
            text-align: right;
            font-size: 0.75em;
            cursor: pointer;
        }

        .DayPicker--interactionDisabled .DayPicker-Day {
            cursor: default;
        }

        .DayPicker-Footer {
            padding-top: 0.5em;
        }

        .DayPicker-TodayButton {
            border: none;
            background-color: transparent;
            background-image: none;
            box-shadow: none;
            color: #4a90e2;
            font-size: 0.875em;
            cursor: pointer;
        }

        /* Default modifiers */

        .DayPicker-Day--today {
            color: #d0021b;
            font-weight: 700;
        }

        .DayPicker-Day--outside {
            color: #8b9898;
            cursor: default;
        }

        .DayPicker-Day--disabled {
            color: #dce0e0;
            cursor: default;
            /* background-color: #eff1f1; */
        }

        /* Example modifiers */

        .DayPicker-Day--sunday {
            background-color: #f7f8f8;
        }

        .DayPicker-Day--sunday:not(.DayPicker-Day--today) {
            color: #dce0e0;
        }

        .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            position: relative;

            background-color: #4a90e2;
            color: #f0f8ff;
        }

        .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
            background-color: #51a0fa;
        }

        .DayPicker:not(.DayPicker--interactionDisabled)
            .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
            background-color: #f0f8ff;
        }

        /* DayPickerInput */

        .DayPickerInput {
            display: inline-block;
        }

        .DayPickerInput-OverlayWrapper {
            position: relative;
        }

        .DayPickerInput-Overlay {
            position: absolute;
            left: 0;
            z-index: 1;

            background: white;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
        }
    }
`;

export const popover = css`
    background: ${Variables.css.catapultWhite};
    border-radius: 4px;
    box-shadow: ${Variables.css.shadow3};
    border-radius: 4px;
    z-index: 10;
    display: flex;
`;

export const presetWrapper = css`
    border-right: 1px solid ${Variables.css.grey6};
    width: 140px;
    padding: ${Variables.css.spacing8} 0;

    [data-theme='dark'] & {
        border-right: 1px solid ${Variables.css.grey3};
        width: 140px;
        padding: ${Variables.css.spacing8} 0;
        background-color: ${Variables.css.grey1};
        color: ${Variables.css.grey1};
    }
`;

export const presetButton = css`
    display: block;
    width: 100%;
    background: transparent;
    border: 0;
    padding: ${Variables.css.spacing12} ${Variables.css.spacing16};
    text-align: left;
    margin: ${Variables.css.spacing4} 0;
    font-size: 14px;
    position: relative;

    &[aria-selected='true'] {
        font-weight: 600;
    }
    [data-theme='dark'] & {
        color: ${Variables.css.catapultWhite};
    }
`;

export const overlay = css`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
`;

export const globals = css`
    :global() {
        .DayPicker {
            color: ${Variables.css.catapultBlack};
        }

        .DayPicker-Caption {
            margin-bottom: 1em;
        }

        .DayPicker-Caption > div {
            font-weight: 600;
            font-size: 16px;
        }

        .DayPicker-Weekday {
            color: ${Variables.css.catapultBlack};
            border-top: 1px solid ${Variables.css.grey6};
            border-bottom: 1px solid ${Variables.css.grey6};
            font-weight: 600;
            font-size: 12px;
            padding: 1em;
        }

        .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
            background-color: ${Variables.css.catapultOrange};
        }

        .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            position: relative;
            background-color: ${Variables.css.catapultOrange};
            color: ${Variables.css.catapultBlack};
            font-weight: 600;
        }

        .DayPicker-Day {
            border-radius: 4px;
            font-size: 12px;
            padding: 1em;
        }

        .DayPicker:not(.DayPicker--interactionDisabled)
            .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
            background-color: hsl(20deg 100% 50% / 16%);
        }

        .DayPicker-range .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            background: hsl(20deg 100% 50% / 16%);
            border-radius: 0;
        }

        .DayPicker-range
            .DayPicker-Day--start.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            background: var(--r-catapult-orange);
            border-radius: 4px 0 0 4px;
        }

        .DayPicker-range
            .DayPicker-Day--end.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            background: var(--r-catapult-orange);
            border-radius: 0 4px 4px 0;
        }

        .DayPicker-range
            .DayPicker-Day--start.DayPicker-Day--end.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
            border-radius: 4px;
        }

        [data-theme='dark'] {
            .DayPicker {
                color: ${Variables.css.catapultWhite};
                background-color: ${Variables.css.grey1};
                border: ${Variables.css.grey3} solid 1px;
            }

            .DayPicker
                .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):not(.DayPicker-Day--today):not(.DayPicker-Day--selected),
            .DayPicker-range
                .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):not(.DayPicker-Day--today) {
                color: ${Variables.css.catapultWhite};
            }
            .DayPicker .DayPicker-Day.DayPicker-Day--outside,
            .DayPicker-range .DayPicker-Day.DayPicker-Day--outside {
                color: ${Variables.css.grey5};
            }

            .DayPicker .DayPicker-Caption > div,
            .DayPicker-range .DayPicker-Caption > div {
                color: ${Variables.css.catapultWhite};
            }

            .DayPicker .DayPicker-Weekday,
            .DayPicker-range .DayPicker-Weekday {
                color: ${Variables.css.catapultWhite};
            }

            .DayPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
                background-color: ${Variables.css.catapultOrange};
            }

            .DayPicker .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
                position: relative;
                background-color: ${Variables.css.catapultOrange};
                color: ${Variables.css.catapultBlack};
                font-weight: 600;
            }

            .DayPicker:not(.DayPicker--interactionDisabled)
                .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover,
            .DayPicker-range:not(.DayPicker--interactionDisabled)
                .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
                background-color: rgba(255, 255, 255, 0.08);
            }

            .DayPicker-range .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
                background: rgba(255, 255, 255, 0.16);
                border-radius: 0;
            }

            .DayPicker-range {
                color: ${Variables.css.catapultWhite};
                background-color: ${Variables.css.grey1};
            }

            .DayPicker-range
                .DayPicker-Day--start.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
                background: ${Variables.css.catapultOrange};
                color: ${Variables.css.catapultBlack};
                border-radius: 4px 0 0 4px;
            }

            .DayPicker-range
                .DayPicker-Day--end.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
                background: ${Variables.css.catapultOrange};
                color: ${Variables.css.catapultBlack};
                border-radius: 0 4px 4px 0;
            }

            .DayPicker-range
                .DayPicker-Day--start.DayPicker-Day--end.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
                border-radius: 4px;
            }

            .DayPicker .DayPicker-Day--today,
            .DayPicker-range .DayPicker-Day--today {
                color: ${Variables.css.catapultOrange};
            }

            .DayPicker .DayPicker-NavButton--prev,
            .DayPicker-range .DayPicker-NavButton--prev {
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAChSURBVHgBzdRBDYAwEETRkYAEJCABCUhAAg5AAg7AARKQgAQkVELZJksyacJp58BPeuDyAnRb4C/lnGdbG1Q5+NYhWgXuiGbIQOBlq0EkA1pbycG7PCOSg7eDSQE2BJZ6RDPkIHBCtGqnF0Qrn0ngAUXVv4xvDsGddIwIHqUDT/BCsPQSWQmeocqwUzqzjupPl8P1PSDbOB61Fqr8jT9v/Qd9fDXaikwSeAAAAABJRU5ErkJggg==');
            }

            .DayPicker .DayPicker-NavButton--next,
            .DayPicker-range .DayPicker-NavButton--next {
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACpSURBVHgBvdRbDYNAEIXhIwEJSKgEnLQOWgfFATiohEqoBCSshEoYziZDmOwjc+BP9oGXj83egKsys47jyzFBFbHB9t5QRewX4DsU+RKUAN+giFAf4H/9hqI6QwfNf9BBEaFHWIYFqoiNAf5AFbH5rKO2BLhHNt+0rYJszfEq6Vk2oOYiNOv4QjYiUwBHZKvHJoAzshF5Sm+Rb4zJdtrRQQoGuM720Iu0AikDMA6mIVbrAAAAAElFTkSuQmCC');
            }

            .DayPicker .DayPicker-NavButton--next,
            .DayPicker .DayPicker-NavButton--prev,
            .DayPicker-range .DayPicker-NavButton--next,
            .DayPicker-range .DayPicker-NavButton--prev {
                &:hover,
                &:focus-visible {
                    background-color: rgba(255, 255, 255, 0.08);
                }
                &:active {
                    background-color: rgba(255, 255, 255, 0.32);
                }
            }
        }
    }
`;

export const clearContainer = css`
    position: absolute;
    width: 40px;
    top: 0;
    right: 0;
    display: flex;
    flex-flow: row-reverse;
    gap: 8px;
`;

export const clearDate = css`
    pointer-events: all;
    cursor: pointer;
`;
